export const visit = (vm, at) => {
at({ "no-no": { "conversations-message-history": { "responder": { "automatic": "Automatisert", "bot": "Robot", "unknownResponder": "Ukjent bruker", "unknownSender": "Ukjent sender", "unknownVisitor": "Ukjent bes\xF8kende", "unknownVisitorAvatar": "Ukjent bes\xF8kende" } } } });
};